import layout from '@/layout';
import routerMap from '../routerMap.js';

const meta = { auth: true };
export default{
  path: '/report',
  name: 'report',
  meta:{...meta,title:"报表中心",hidden:true},
  component: layout,
  children: ((pre,prePath) => [

    { path: `${prePath}purchasein/purchasein`, name: `${pre}purchasein-purchasein`, component:routerMap.reportPurchasein, meta: { ...meta, title: '采购报表' } },
    { path: `${prePath}sale/sale`, name: `${pre}sale-sale`, component:routerMap.reportSale, meta: { ...meta, title: '销售报表' } },
    { path: `${prePath}stock/stock`, name: `${pre}stock-stock`, component:routerMap.reportStock, meta: { ...meta, title: '当期库存报表' } },
    { path: `${prePath}stock/period`, name: `${pre}stock-period`, component:routerMap.reportPeriod, meta: { ...meta, title: '期间库存报表' } },
    { path: `${prePath}multiple/jxc`, name: `${pre}multiple-jxc`, component:routerMap.reportMultiple, meta: { ...meta, title: '进销存报表' } },
    { path: `${prePath}multiple/materialreport`, name: `${pre}multiple-materialreport`, component:routerMap.reportMaterialreport, meta: { ...meta, title: '物料移动单据表' } },

  ])('report-','/report/')
}
